import { Box, VStack, Text, Image } from "@chakra-ui/react";
import EmptyListImage from "@/assets/svg/empty-list.svg";

const EmptyList = () => {
  return (
    <Box
      id="empty section"
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="500px"
    >
      <VStack spacing={4} textAlign="center">
        {/* Illustration */}
        <Box>
          <Image
            src={EmptyListImage} // Replace with actual illustration URL
            alt="Empty State Illustration"
            width="500px"
            height="auto"
          />
        </Box>

        {/* Text */}
        <Text fontSize="lg" fontWeight="bold">
          Ooops! It’s Empty
        </Text>
        <Text fontSize="md" color="gray.500">
          Looks like you don’t have anything in your list.
        </Text>
      </VStack>
    </Box>
  );
};

export default EmptyList;
